import React, { FC } from "react";
import { RootState } from "store/ducks";
import { useSelector } from "react-redux";
//components
import { Visibility } from "components/Visibility";
import { IsNullOrEmpty } from "utils/StringNullOrEmpty";
import Input from "pages/Quotes/components/generics/Input/Input";
//assets
import lockIcon from "img/RedLockIcon.svg";
import olIcon from "img/OLIconViveo.svg";
import factoryPriceIcon from "img/icon-factoryPrice.svg";
import agreementPriceIcon from "img/agreement-price.svg";
//patterns
import { currencyPositive } from "pages/Quotes/utils/patterns";
import { TooltipIcon } from "pages/Quotes/components/TooltipIcon";
import { convertFromFloat } from "pages/Quotes/utils/numberFormatBR";
//interfaces
import { UnitPriceProps } from "./interface";
//utils
import { RoundDecimalNumber } from "utils/RoundingDecimal";
//context
import { useExceptionPriceBelowMinContext } from "contexts/ExceptionPriceBelowMin";
//style
import './style.scss';

export const UnitPrice: FC<UnitPriceProps> = ({
  item,
  stock,
  isEditing,
  unitPrice,
  listCemed,
  openTooltip,
  minimumPrice,
  setUnitPrice,
  setOpenTooltip,
  setRentability,
  updatedMinPrice,
  readOnly = false,
  unitPriceMessage,
  minimumPriceLock,
  segmentComparison,
  showMinPriceModal,
  formatedUnitPrice,
  unitPriceValidator,
  setMinimumPriceLock,
  blockedMinimumPrice,
  setShowMinPriceModal,
  handleKeepFactoryPrice,
  tooltipText
}) => {
  const user = useSelector((state: RootState) => state.user);
  const factoryPrice = stock?.factoryPrice && Number(stock?.factoryPrice.toFixed(2));
  const { updateExceptionPriceBelowMinState } = useExceptionPriceBelowMinContext();

  const convertedUnitValue =
    String(unitPrice) === "-"
      ? unitPrice
      : Number(unitPrice?.toString().replace(",", ".")).toLocaleString("pt-BR", {
        maximumFractionDigits: 2,
        useGrouping: false,
      });

  const editingItemNoAgreement = isEditing && stock?.agreementPrice === 0 && !stock?.isPricedAccordingly;
  const itemWithoutOlAgreement = !stock?.isPricedAccordingly && !stock?.ol && Number(stock?.olPrice) === 0;
  const calcUnitePrice = IsNullOrEmpty(unitPrice) ? false : Math.abs(Number(unitPrice?.toFixed(2)) - factoryPrice) < 0.0001;
  const renderIconFactoryPrice = isEditing && factoryPrice > 0 && calcUnitePrice && itemWithoutOlAgreement;
  const renderIconAgreementPrice = isEditing && Number(stock.agreementPrice?.toFixed(2)) === Number(unitPrice?.toFixed(2)) && stock.isPricedAccordingly;
  const renderIconOlPrice = editingItemNoAgreement && Number(stock?.olPrice) > 0;
  const renderLockUnitPrice = editingItemNoAgreement && Number(stock?.olPrice) === 0;
  const renderIconTextOlPrice = editingItemNoAgreement && Number(stock?.olPrice) > 0 && Number(unitPrice?.toFixed(2)) === Number(stock?.olPrice.toFixed(2));
  const renderLockIconUnitPrice = isEditing && (openTooltip.unitPrice && !blockedMinimumPrice) && minimumPriceLock && !segmentComparison && itemWithoutOlAgreement && !renderIconOlPrice;
  const suggestedItem = item.productsSuggestion?.find((product: any) => product.suggested == true);
  const valueMultiple = item?.priorityBCG?.maps?.find((map: any) => map.codProdMafra === suggestedItem?.supplierProductcode)?.multiple ?? 1; 
  const valuePricing = RoundDecimalNumber(Number((minimumPrice * valueMultiple).toFixed(2)), 2);
  const showMultipliedPriceMessage = user?.isBCGUser && item.priorityBCG && valueMultiple && unitPrice < valuePricing && itemWithoutOlAgreement;

  const handleVerifyUnitPrice = () => {
    if (!listCemed && factoryPrice <= 0) {
      const commercialCost = stock?.commercialCost || 0;
      const commercialCostRule = ((openTooltip.unitPriceValue - commercialCost) / openTooltip.unitPriceValue) * 100;

      setRentability(convertFromFloat(commercialCostRule));
    } else
      unitPriceValidator(openTooltip.unitPriceValue, stock, stock?.ol ? true : undefined);

    if (user?.isBCGUser && itemWithoutOlAgreement)
      setUnitPrice(valuePricing);
    else if (updatedMinPrice > 0)
      setUnitPrice(RoundDecimalNumber(Number(updatedMinPrice), 2));
    else
      setUnitPrice(RoundDecimalNumber(Number(openTooltip.unitPriceValue), 2));

    setMinimumPriceLock(false);
    setOpenTooltip({ ...openTooltip, unitPrice: false });
    updateExceptionPriceBelowMinState(false);
  };

  const handleUnitPrice = (value: string) => {
    value = value.replace(".", "");
    const splittedValue = value.split(',')[1];

    if (splittedValue === "0")
      value = Number(value.replace(',', '.')).toFixed(1);

    stock?.isPricedAccordingly || stock?.olPrice > 0 ?
      unitPriceValidator(!IsNullOrEmpty(value) ? Number(value.replace(',', '.')) : value, stock, true)
      :
      unitPriceValidator(!IsNullOrEmpty(value) ? Number(value.replace(',', '.')) : value, stock);
  };

  return (
    <div className="unitValue">
      <span className="subtitle">Preço de Venda</span>
      <div className="value" style={{ alignItems: "baseline" }}>
        {!isEditing ? (
          <div className="value">{formatedUnitPrice}</div>
        ) : (
          <Input
            width="89px"
            type="number"
            readOnly={readOnly}
            alt='inputUnitPrice'
            setIsValid={() => { }}
            isValid={((blockedMinimumPrice || !minimumPriceLock) && convertedUnitValue !== "0") || (!(stock.minimumPriceLock1 >= 0) && !segmentComparison) || renderIconOlPrice}
            value={String(convertedUnitValue)}
            pattern={currencyPositive}
            isPricedAccordingly={renderIconAgreementPrice}
            ol={renderIconTextOlPrice}
            onChange={(event: any) => {
              handleUnitPrice(event);
              updateExceptionPriceBelowMinState(false);
            }}
            onBlur={(!stock?.isPricedAccordingly && !stock.ol) && handleKeepFactoryPrice}
            tooltipText={tooltipText}
          />
        )}

        <Visibility visible={renderLockIconUnitPrice}>
          <div className="lockIconUnitPrice ml-1">
            <img
              src={lockIcon}
              alt="lockIcon"
              onClick={() =>
                showMinPriceModal === true
                  ? null
                  : setShowMinPriceModal(true)
              }
            />
          </div>
        </Visibility>

        <Visibility visible={renderIconFactoryPrice}>
          <div className="factoryPriceIcon">
            <TooltipIcon alt="factoryPriceIcon" icon={factoryPriceIcon} tooltip="Preço de Fábrica" />
          </div>
        </Visibility>

        <Visibility visible={renderIconAgreementPrice}>
          <div className="agreementPriceIcon">
            <TooltipIcon alt="agreementPriceIcon" icon={agreementPriceIcon} tooltip="Preço de Acordo" />
          </div>
        </Visibility>

        <Visibility visible={renderIconTextOlPrice}>
          <div className="agreementPriceIcon">
            <TooltipIcon alt="olPriceIcon" icon={olIcon} tooltip="Preço de OL" />
          </div>
        </Visibility>
      </div>

      <Visibility visible={!user?.isBCGUser && !showMultipliedPriceMessage && minimumPriceLock && isEditing && renderLockUnitPrice}>
        <div className="unitPriceWarning">
          <Visibility visible={!segmentComparison}>
            <span style={{ color: "#DE2248" }}>Abaixo do mínimo</span>
          </Visibility>
          <a onClick={() => { handleVerifyUnitPrice(); }} title="mensagem preço abaixo do mínimo">
            <span className="hintWarning">{unitPriceMessage}</span>
          </a>
        </div>
      </Visibility>

      <Visibility visible={showMultipliedPriceMessage && isEditing}>
        <div className="unitPriceWarning">
          <a onClick={() => { handleVerifyUnitPrice(); }} title="mensagem aplicar preço recomendado">
            <span className="hintWarning">{unitPriceMessage}</span>
          </a>
        </div>
      </Visibility>

      <Visibility visible={minimumPriceLock && isEditing && !renderIconTextOlPrice && !renderLockUnitPrice}>
        <div className="unitPriceWarning">
          <a onClick={() => { handleVerifyUnitPrice(); }} title="mensagem preço abaixo do ol">
            <span className="hintWarning hintOl">
              {unitPriceMessage}
            </span>
          </a>
        </div>
      </Visibility>
    </div>
  );
};